import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-236a2658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generalCont table m-auto text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "NFT STAKING")
], -1))
const _hoisted_3 = { class: "counts flex justify-center flex-wrap lg:gap-16 md:gap-8 gap-6" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "TOTAL STAKED", -1))
const _hoisted_6 = { class: "count" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "YOUR NFTS STAKED", -1))
const _hoisted_8 = { class: "count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.farmAcc.gemsStaked), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h3", null, _toDisplayString((_ctx.availableA/1000000000).toFixed(3)) + " $PLG", 1),
        _createElementVNode("p", null, [
          _createTextVNode("ESTIMATED EARNINGS "),
          _createElementVNode("button", {
            class: "btnHighlighted",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
          }, "Claim")
        ])
      ])
    ])
  ]))
}